import {
    Datagrid, List, TextField, ReferenceField, ShowButton,
    Pagination, useRecordContext,
    ReferenceInput,
    AutocompleteInput,
    SimpleList,
    ShowButtonProps
} from "react-admin";
import ForwardOutlinedIcon from '@mui/icons-material/ForwardOutlined';
import { MessageField } from "./MessageField";
import { DateTimeField } from "@/src/components";
import { Box, Stack, useMediaQuery, listItemIconClasses, listItemClasses } from "@mui/material";
import { blueGrey } from '@mui/material/colors'
const MessagesPagination = () => <Pagination rowsPerPageOptions={[50, 100, 200]} />;

const filters = [
    <ReferenceInput label="User" source="sender or to" reference="user" allowEmpty alwaysOn>
        <AutocompleteInput label="User" optionText="profile.nickname"
            filterToQuery={(txt) => ({ profile: { nickname: txt } })}
            size='small'
            // suggestionLimit={10}
            />
    </ReferenceInput>

]

export const MessageList = () => {
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));


    return (
        <List
            sort={{ field: 'createdAt', order: 'DESC' }}
            filters={filters}
            perPage={100}
            pagination={<MessagesPagination />}
            exporter={false}
        >
            {isSmall ? (
                <SimpleList
                    sx={{
                        [`& .${listItemIconClasses.root}`]: {
                            minWidth: "40px"
                        },
                        [`& .${listItemClasses.root}`]: {
                            paddingLeft: "8px",
                            paddingRight: "8px"
                        }
                    }}
                    leftIcon={() => <ShowConversationButton />}
                    secondaryText={<MessageField source="content" type="type" />}
                    // primaryText={record => record.content}
                    primaryText={
                        <Stack direction={"row"} flexWrap={"wrap"}>
                            <ReferenceField
                                queryOptions={{ staleTime: Infinity, gcTime: 10 * 60 * 1000 }}
                                label="From" source="sender" reference="user"
                                sx={{ maxWidth: "70dvw", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            >
                                <TextField source="profile.nickname" variant="body1" sx={{ fontSize: "0.8rem", color: blueGrey[900] }} />
                            </ReferenceField>
                            <ForwardOutlinedIcon fontSize={"small"} htmlColor={blueGrey[700]} />
                            <ReferenceField
                                queryOptions={{ staleTime: Infinity, gcTime: 10 * 60 * 1000 }}
                                label="To" source="to" reference="user"
                                sx={{ maxWidth: "70dvw", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            >
                                <TextField source="profile.nickname" variant="body1" sx={{ fontSize: "0.8rem", color: blueGrey[700] }} />
                            </ReferenceField>
                        </Stack>
                    }
                    tertiaryText={record => <DateTimeField record={record} source="sent" />}
                // rowClick="edit"
                />
            ) : (
                <Datagrid bulkActionButtons={false}>



                    <ReferenceField label="From" source="sender" reference="user">
                        <TextField source="profile.nickname" />
                    </ReferenceField>

                    <ReferenceField label="To" source="to" reference="user">
                        <TextField source="profile.nickname" />
                    </ReferenceField>
                    <MessageField source="content" type="type" />

                    {/* <TextField source="id" /> */}
                    {/* <TextField source="received" /> */}
                    {/* <TextField source="type" /> */}
                    {/* <TextField source="conversation" /> */}
                    <ShowConversationButton />
                    {/* <TextField source="text" /> */}
                    {/* <TextField source="content" /> */}
                    <DateTimeField source="sent" />
                    {/* <DateField source="createdAt" /> */}
                    {/* <DateField source="updatedAt" /> */}

                    {/* <TextField source="sender" />
                    <TextField source="to" /> */}
                </Datagrid>
            )}
        </List>
    )
};

const ShowConversationButton = (props: ShowButtonProps) => {
    const record = useRecordContext(props);
    return record && (
        <ShowButton resource="conversation" record={{ id: record.conversation }} {...props} />
    );
}

